export const handleClickToCopy = (value) => {
    navigator.clipboard.writeText(value).then(() => {
    }, () => {
        console.error('Failed to copy');
    });
}